<template>

    <footer>
        <div class="row-black">
            <div class="content-960 clearfix">

                <ul class="list-icons">
                    <li>
                        <a target="_blank" href="https://pt-br.facebook.com/CNAoficial/" title="Facebook">
                            <div class="fa fa-facebook"></div>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="https://twitter.com/cnaoficial" title="Twitter">
                            <div class="fa fa-twitter"></div>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.instagram.com/cnaoficial" title="Instagram">
                            <div class="fa fa-instagram"></div>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="https://br.linkedin.com/company/cna-ensino-de-linguas" title="Linkedin">
                            <div class="fa fa-linkedin"></div>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.youtube.com/user/cnaoficial" title="Youtube">
                            <div class="fa fa-youtube"></div>
                        </a>
                    </li>
                </ul>

            </div>
        </div>

        <div class="row">
            <div class="content-960 clearfix">
                <a href="#" title="Copyright © CNA.com.br - Todos os direitos reservados.">Copyright © CNA.com.br - Todos os direitos reservados.</a>
                <a href="#" title="Política de Privacidade">Política de uso</a>
            </div>
            <div class="content-960 clearfix" v-if="changelog">
                <button class="btn btn-link" @click="dialogChangeLog = true" style="padding: 0;color: #272727;font-size: 11px;">
                    Versão {{changelog.versao}}
                </button>
            </div>
        </div>

        <b-modal v-if="changelog" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogChangeLog" :hide-footer="true" :title="'Versão de ' + changelog.data">
            <div v-html="changelog.detalhes"></div>
        </b-modal>

    </footer>

</template>
<script>

    import { Api } from '@/common/api'
    import Global from '@/common/global'

    export default {
        name: "footer-cna",
        data() {
            return {
                changelog: null,
                dialogChangeLog: false
            };
        },
        mounted() {
            new Api('changelog/more', Global.END_POINT_PORTAL_CORPORATIVO).get({
                filterBehavior: 'GetDataCustom',
                chaveIdentificacaoSistema: Global.CHAVE_IDENTIFICACAO_SISTEMA
            }).then(result => {
                this.changelog = result.data;
            })
        }

    };
</script>